/**
 * folderSearch · 按关键词模糊搜索文件夹（接口 2）
 *
 * 后端：POST /web/folder/search · book_name LIKE 匹配，按更新时间倒序。
 * 协议特点（接口文档强调）：除"未登录 401"外 HTTP 恒 200——
 * 参数错在 body.code（400 = keyword 空），业务错在 body.data.status
 * （-2 = 团队不存在），必须逐层判定。
 */

declare const __API_SERVER_HOST__: string

/** 接口 2 返回的单个文件夹（仅声明前端用到的字段） */
export interface FolderSearchItem {
  /** 文件夹 ID · 跳详情用 */
  folderID: number
  folderName: string
  /** 本文件夹照片数 */
  photoCount: number
  /** 子文件夹数 */
  folderCount: number
  /** 更新时间 · Unix 秒 */
  folderUpdateTime: number
  /** 是否 AI 智能文件夹 · 图标加刷新水印 */
  isIntelligenceFolder: boolean
}

interface FolderSearchResponse {
  code?: number
  msg?: string
  data?: {
    status?: number
    msg?: string
    data?: FolderSearchItem[] | null
  }
}

/**
 * 搜索团队内文件夹。
 *
 * @param params - groupID 团队 UUID；keyword 非空关键词（空串由调用方拦截）；
 *                 limit 条数上限（服务端兜底 0/负→30、>100→100）
 * @param signal - 可选的取消信号（输入变化时中止过期请求）
 * @returns 命中的文件夹列表（无命中为空数组）
 * @throws HTTP 非 200 / body.code 非 200 / data.status 非 0 时抛错
 */
export async function searchFolders(
  params: { groupID: string; keyword: string; limit?: number },
  signal?: AbortSignal
): Promise<FolderSearchItem[]> {
  const url = __API_SERVER_HOST__ + '/web/folder/search'
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      groupID: params.groupID,
      keyword: params.keyword,
      limit: params.limit ?? 30
    }),
    signal
  })
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${res.statusText}`)
  }
  const body = (await res.json()) as FolderSearchResponse
  if (body.code !== 200) {
    throw new Error(body.msg || `搜索失败 code=${body.code}`)
  }
  if (!body.data || body.data.status !== 0) {
    throw new Error(body.data?.msg || `搜索失败 status=${body.data?.status}`)
  }
  return Array.isArray(body.data.data) ? body.data.data : []
}
